const provinces = (state) => state.provinces;
const districts = (state) => state.districts;
const communes = (state) => state.communes;
const danhSachNguonPAKN = (state) => state.danhSachNguonPAKN;
const danhSachLuatPAKN = (state) => state.danhSachLuatPAKN;
const danhSachNoiDungPAKN = (state) => state.danhSachNoiDungPAKN;
const danhSachLinhVucPAKN =(state) => state.danhSachLinhVucPAKN;

export default {
  provinces,
  districts,
  communes,
  danhSachNguonPAKN,
  danhSachLuatPAKN,
  danhSachNoiDungPAKN,
  danhSachLinhVucPAKN
};
